import { Module } from 'vuex';

import { marketplacePaymentImportsService } from '@/services/marketplace-payment-imports/marketplace-payment-imports.service';
import {
  MarketplacePaymentImport,
  MarketplacePaymentPayload
} from '@/services/marketplace-payment-imports/marketplace-payment-imports.types';
import { RootState } from '@/store';

export interface MarketplacePaymentImportState {
  marketplacePaymentImports: MarketplacePaymentImport[];
  marketplacePaymentImportsLoading: boolean;
  marketplacePaymentImport: MarketplacePaymentImport | null;
  marketplacePaymentImportLoading: boolean;
}

const state: MarketplacePaymentImportState = {
  marketplacePaymentImports: [],
  marketplacePaymentImportsLoading: false,
  marketplacePaymentImport: null,
  marketplacePaymentImportLoading: false
};

const options: Module<MarketplacePaymentImportState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    listMarketplacePaymentImports: ({ commit, dispatch }, marketplaceId?: number | string): Promise<void> => {
      commit('marketplacePaymentImportsLoading', true);
      return marketplacePaymentImportsService
        .list({ marketplace_id: marketplaceId })
        .then(imports => commit('marketplacePaymentImports', imports || []))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('marketplacePaymentImportsLoading', false));
    },
    getMarketplacePaymentImport: ({ commit, dispatch }, id: number): Promise<void> => {
      commit('marketplacePaymentImportLoading', true);
      return marketplacePaymentImportsService
        .get(id)
        .then(item => item && commit('marketplacePaymentImport', item))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('marketplacePaymentImportLoading', false));
    },
    clearMarketplacePaymentImport: ({ commit }): void => {
      commit('marketplacePaymentImport', null);
    },
    destroyMarketplacePaymentImport: ({ commit, dispatch }, id: number): Promise<void> => {
      commit('marketplacePaymentImportLoading', true);
      return marketplacePaymentImportsService
        .destroy(id)
        .then(() => commit('marketplacePaymentImport', null))
        .then(() => dispatch('alert/pushSuccess', 'Import supprimé !', { root: true }))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('marketplacePaymentImportLoading', false));
    },
    updateMarketplacePayment: (
      { commit, dispatch, state },
      { id, payload }: { id: number; payload: Partial<MarketplacePaymentPayload> }
    ): Promise<void> => {
      commit('marketplacePaymentImportLoading', true);
      return marketplacePaymentImportsService
        .updatePayment(id, payload)
        .then(payment => {
          if (!state.marketplacePaymentImport || !payment) return;
          const payments = state.marketplacePaymentImport.marketplace_payments.map(p =>
            p.id === payment.id ? payment : p
          );
          commit('marketplacePaymentImport', {
            ...state.marketplacePaymentImport,
            marketplace_payments: payments
          });
        })
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('marketplacePaymentImportLoading', false));
    }
  },
  mutations: {
    marketplacePaymentImports: (state, imports: MarketplacePaymentImport[]) =>
      (state.marketplacePaymentImports = imports),
    marketplacePaymentImportsLoading: (state, loading: boolean) => (state.marketplacePaymentImportsLoading = loading),
    marketplacePaymentImport: (state, item: MarketplacePaymentImport) => (state.marketplacePaymentImport = item),
    marketplacePaymentImportLoading: (state, loading: boolean) => (state.marketplacePaymentImportLoading = loading)
  }
};

export default options;
